"use strict";

export default function () {
    const paragrafos = document.querySelectorAll(
        ".single-post .single-post__columns article p"
    );

    // Verifique se existem pelo menos 4 parágrafos
    if (paragrafos.length >= 3) {
        // Seleciona o quarto parágrafo (índice 3) e insere a div depois dele
        const quartoParagrafo = paragrafos[2];
        const divIntext1 = document.createElement("div");
        divIntext1.id = "intext1_alright";
        divIntext1.style.minHeight = "100px";
        quartoParagrafo.insertAdjacentElement("afterend", divIntext1);
    } else {
        console.error("Não há parágrafos suficientes para inserir a div.");
    }
}
